import formatDate, { DATE_FORMATS } from 'common/tools/date/format';
import trans from 'common/tools/translations/trans';

/**
 * Label of the night a midnight showtime belongs to, from the day it is displayed under (the
 * `displayDate` of getShowtimeDisplayDay): "Nuit du 24 au 25 février" when both days share a
 * month, "Nuit du 28 février au 1 mars" otherwise (ALLOCINE-15181). The month is spelled once in
 * the first case, so the connectors have to live in the translations. The Twig counterpart is
 * the `render_version` macro of showtimes-versions-holder.html.twig, keep both in sync.
 */
const getMidnightNightLabel = (from: Date): string => {
  const to = new Date(from.getFullYear(), from.getMonth(), from.getDate() + 1);
  // consecutive days: sharing a month means sharing the year too
  const sameMonth = from.getMonth() === to.getMonth();

  // no timeZone override: from/to are built from local date components
  // (see getShowtimeDisplayDay), formatting them as UTC would shift the day backwards
  // for any timezone ahead of UTC (France included).
  return trans(
    sameMonth
      ? 'showtimes.midnight_screening.night_of_same_month'
      : 'showtimes.midnight_screening.night_of',
    {
      from: formatDate(
        from,
        sameMonth ? DATE_FORMATS.DAY : DATE_FORMATS.DAY_MONTH
      ),
      to: formatDate(to, DATE_FORMATS.DAY_MONTH)
    }
  );
};

export default getMidnightNightLabel;
